import React from 'react';
import './CassetteTape.css';

const CassetteTape = ({ blogPost, onSelect }) => {
  const formatDate = (date) => {
    if (!date) return "";
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  };

  // Extract the three button colors from blogPost or use defaults
  const stripe1Color = blogPost.windowGradientStart || '#ffcc29';
  const stripe2Color = blogPost.minimizeButton || '#49dcdc';
  const stripe3Color = blogPost.maximizeButton || '#b967ff';
  const stripe4Color = blogPost.closeButton || '#b967ff';

  // Create reel spokes/lines
  const createReelSpokes = () => {
    const spokes = [];
    for (let i = 0; i < 6; i++) {
      const angle = (i * 60); // 6 spokes, 60 degrees apart
      spokes.push(
        <div 
          key={i} 
          className="reel-spoke"
          style={{ transform: `translate(-50%, -50%) rotate(${angle}deg)` }}
        />
      );
    }
    return spokes;
  };

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`cassette-tape ${isHovered ? 'hovered' : ''}`}
      onClick={() => onSelect(blogPost)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Enhanced Screws with crosses and shadows */}
      <div className="screw top-left">
        <div className="screw-cross">
          <div className="screw-cross-vertical" />
          <div className="screw-cross-horizontal" />
        </div>
      </div>
      <div className="screw top-right">
        <div className="screw-cross">
          <div className="screw-cross-vertical" />
          <div className="screw-cross-horizontal" />
        </div>
      </div>
      <div className="screw bottom-left">
        <div className="screw-cross">
          <div className="screw-cross-vertical" />
          <div className="screw-cross-horizontal" />
        </div>
      </div>
      <div className="screw bottom-right">
        <div className="screw-cross">
          <div className="screw-cross-vertical" />
          <div className="screw-cross-horizontal" />
        </div>
      </div>

      {/* Label Area */}
      <div className="label-area">
        {/* Title at the top */}
        <div className="title-container">
          <div className="title">
            {blogPost.title}
          </div>
        </div>

        {/* Stripes in the middle */}
        <div className="stripe-container">
          <div className="stripe stripe-1" style={{ backgroundColor: stripe1Color }} />
          <div className="stripe stripe-2" style={{ backgroundColor: stripe2Color }} />
          <div className="stripe stripe-3" style={{ backgroundColor: stripe3Color }} />
          <div className="stripe stripe-4" style={{ backgroundColor: stripe4Color }} />
        </div>

        {/* Tagline at the bottom */}
        <div className="tagline-container">
          <div className="tagline">
            {blogPost.tagline}
          </div>
          <div className="cassette-line" />
        </div>

        {/* Date and Word Count */}
        <div className="meta-area">
          <span>{formatDate(blogPost.date)}</span>
          <span>{blogPost.wordCount} words</span>
        </div>
      </div>

      {/* Tape Housing positioned with stripes in middle area */}
      <div className="tape-housing">
        <div className="tape-window">
          {/* Left Reel */}
          <div className={`reel left-reel ${isHovered ? 'spinning' : ''}`}>
            <div className="reel-center" />
            {createReelSpokes()}
          </div>
          
          {/* Right Reel */}
          <div className={`reel right-reel ${isHovered ? 'spinning' : ''}`}>
            <div className="reel-center" />
            {createReelSpokes()}
          </div>
          
          {/* Transparent window between reels */}
          <div className="transparent-window" />

          {/* Tape connecting the reels */}
          <div className="tape" />
        </div>
      </div>

      {/* Bottom Trapezium Section */}
      <div className="bottom-trapezium" />

      {/* Tags */}
      <div className="tags-area">
        {blogPost.tags && blogPost.tags.slice(0, 4).map((tag, index) => (
          <span key={index} className="tag">
            {tag}
          </span>
        ))}
        {blogPost.tags && blogPost.tags.length > 4 && (
          <span className="tag">+{blogPost.tags.length - 4}</span>
        )}
      </div>
    </div>
  );
};

export default CassetteTape;